import {FC, useRef, useState} from 'react'
import {KTSVG} from '_metronic/helpers'

type Props = {
  filter: any
  setFilter: (value: any) => any
}

const OrderSearchFilter: FC<Props> = ({filter, setFilter}) => {
  const [search, setSearch] = useState<any>(filter.name || filter.orderNumber)
  const timeoutRef = useRef<any>(null)

  const handleSearch = async (e: any) => {
    const {value} = e.target
    const isCheckNumber = /^[0-9]+$/.test(value)
    if (!isCheckNumber) {
      handleFilterChange({...filter, name: value, offset: 0})
    }
    if (!value) {
      handleFilterChange({...filter, name: null, orderNumber: null, offset: 0})
    }
    setSearch(value)
  }
  const handleClick = () => {
    const isCheckNumber = /^[0-9]+$/.test(search)
    if (isCheckNumber && search) {
      setFilter({...filter, orderNumber: search, offset: 0})
    }
    if (!isCheckNumber && search) {
      setFilter({...filter, name: search, offset: 0})
    }
  }
  const keyPress = (e: any) => {
    if (e.keyCode === 13) {
      const {value} = e.target
      const isCheckNumber = /^[0-9]+$/.test(value)
      if (isCheckNumber && value) {
        setFilter({...filter, orderNumber: value, offset: 0})
      }
      if (!isCheckNumber && value) {
        setFilter({...filter, name: value, offset: 0})
      }
    }
  }

  const handleFilterChange = (filter: any) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }
    const exec = () => setFilter(filter)
    const timeoutId = setTimeout(exec, 1000)
    timeoutRef.current = timeoutId
  }

  return (
    <div className='d-flex justify-content-end position-relative my-1 pb-5 '>
      <input
        id='txtSearch'
        className='form-control rounded-0 border-gray-400'
        name='search'
        placeholder='Search by customer name and order numbers ...'
        type='text'
        onKeyDown={keyPress}
        autoComplete='off'
        onChange={handleSearch}
        value={search}
      />

      <button
        type='submit'
        onClick={handleClick}
        className='svg-icon svg-icon-1 position-absolute py-2 pb-1 btn'
      >
        <KTSVG path='/media/icons/duotune/general/gen021.svg' className='ms-3' />
      </button>
    </div>
  )
}
export default OrderSearchFilter
